<script setup lang="ts">
  import { useSnackBarStore } from "~/stores/SnackBarStore";

  const snackBarStore = useSnackBarStore();

  interface Props {
    disabled: boolean;
    talkRoomId: string;
    replyTalkId?: string;
    threadTalkId: string;
    showInRoom: boolean;
  }
  const props = defineProps<Props>();

  interface Emits {
    (event: "send"): void;
  }
  const emit = defineEmits<Emits>();

  const fileInput = ref<null | HTMLInputElement>(null);

  const acceptFiles = computed<string>(() => acceptableTalkUploadExtentions.join(","));

  const attachedFiles = ref<any[]>([]);

  const fileDialog = ref<boolean>(false);
  watch(fileDialog, () => {
    if (!fileDialog.value) {
      // fileDialog クローズ時に v-file-input で毎回 @change を発動させるために value をリセット
      if (fileInput.value) {
        fileInput.value.value = "";
      }
    }
  });

  // v-text-field から v-file-input へクリックイベントを伝搬させる
  const onFileInput = () => {
    if (props.disabled) return;
    fileInput.value?.click();
  };

  // 添付ファイル設定時の処理
  const onFileSet = (event: InputEvent) => {
    const selectFiles = (event.target! as HTMLInputElement).files!;
    validateSendFiles(selectFiles);
  };

  const validateSendFiles = (sendFiles: FileList) => {
    const files = [];
    try {
      let fileSize = 0;
      for (let i = 0; i < sendFiles.length; i++) {
        const file = sendFiles[i];
        if (isImageFile(file) || isPdfFile(file)) {
          files.push(file);
          fileSize += file.size;
        }
      }

      if (files.length > 10) {
        snackBarStore.setError("同時に送信できるファイル数は10枚以下です。");
        return false;
      }
      if (fileSize > 20 * 1000000) {
        snackBarStore.setError("ファイルサイズは20MB以下です。");
        return false;
      }
      if (files.length === 0) {
        snackBarStore.setError("送信できるファイル形式はJPG、PNG、PDFのみです");
        return false;
      }
    } catch {
      snackBarStore.setError("エラーが発生しました");
      return false;
    }

    if (files.length > 0) {
      attachedFiles.value = files;
      fileDialog.value = true;
    }
    return true;
  };

  defineExpose({
    validateSendFiles,
  });
</script>

<template>
  <div class="d-flex">
    <v-sheet class="talkroom_input_action" color="transparent" @click="onFileInput">
      <AtomsSvgIcon :width="18" :height="18" :img-path="`assets/images/icon/chat-file-input.svg`" />
      <v-file-input
        ref="fileInput"
        class="d-none"
        label="ファイルを選択"
        :accept="acceptFiles"
        multiple
        @change="onFileSet"
      ></v-file-input>
    </v-sheet>
    <div style="width: 10px"></div>

    <!-- ファイル投稿用ダイアログ -->
    <OrganismsTalkFileDialog
      v-if="fileDialog"
      v-model:open="fileDialog"
      :talk-room-id="talkRoomId"
      :files="attachedFiles"
      :reply-talk-id="replyTalkId"
      :thread-talk-id="threadTalkId"
      :show-in-room="showInRoom"
      @send="emit('send')"
    ></OrganismsTalkFileDialog>
  </div>
</template>

<style lang="scss" scoped>
  .talkroom_input_action {
    width: 40px;
    min-width: 40px;
    cursor: pointer;
    > div {
      margin: 0 auto;
    }
  }
</style>
